if (!customElements.get('subscription-popup')) {
  customElements.define(
    'subscription-popup',
    class SubscriptionPopup extends DrawerComponent {
      static get observedAttributes() {
        return super.observedAttributes.concat([
          'data-trigger-open',
          'data-repeat-open',
        ]);
      }

      constructor() {
        super();

        this.storageKey = 'grenada_popup_consultation_closed';
        this.storageDays = 14;
      }

      get requiresBodyAppended() {
        return false;
      }

      connectedCallback() {
        super.connectedCallback();

        window.FoxTheme.utils.addEventDelegate({
          context: this,
          selector: '.btn-apply-coupon-code',
          handler: async (e, target) => {
            e.preventDefault();

            const code = target.dataset.code;

            if (code) {
              this.copyToClipboard(code, target);
            }
          },
        });

        window.FoxTheme.DOMready(
          this.handleOpen.bind(this)
        );

        const closeButton = this.querySelector(
          '.drawer__close-btn'
        );

        closeButton?.addEventListener('click', () => {
          localStorage.setItem(
            this.storageKey,
            Date.now().toString()
          );
        });
      }

      prepareToShow() {
        super.prepareToShow();
      }

      handleOpen() {
        if (Shopify.designMode) {
          return;
        }

        if (this.closedRecently()) {
          return;
        }

        this.triggerAfterScroll(
          this.show.bind(this)
        );
      }

      closedRecently() {
        const closedAt = localStorage.getItem(
          this.storageKey
        );

        if (!closedAt) {
          return false;
        }

        const elapsed =
          Date.now() - Number(closedAt);

        const days =
          elapsed / (1000 * 60 * 60 * 24);

        if (days < this.storageDays) {
          return true;
        }

        localStorage.removeItem(
          this.storageKey
        );

        return false;
      }

      triggerAfterScroll(trigger) {
        let opened = false;

        const checkScroll = () => {
          const scrollTop =
            window.pageYOffset ||
            document.documentElement.scrollTop;

          const documentHeight =
            document.documentElement.scrollHeight;

          const windowHeight =
            window.innerHeight;

          const scrollableHeight =
            documentHeight - windowHeight;

          if (scrollableHeight <= 0) {
            return;
          }

          const scrollPercent =
            (scrollTop / scrollableHeight) * 100;

          if (scrollPercent >= 50 && !opened) {
            opened = true;

            trigger();

            window.removeEventListener(
              'scroll',
              checkScroll
            );
          }
        };

        window.addEventListener(
          'scroll',
          checkScroll,
          { passive: true }
        );
      }

      copyToClipboard(code, button) {
        navigator.clipboard.writeText(code);
        button.innerText =
          button.dataset.copiedText;
      }
    }
  );
}